import axios from "axios";
import qs from "qs";
import NProgress from "nprogress";
import {storejs} from "../common/js/util";
import { Message } from "element-ui";
import store from "../store";

import {
  Deviceinfo
} from '../utils/global-methods'


var apiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 10000,
  withCredentials: true,
});

//暂时不支持token传输
var apiCloudInstance = axios.create({
  baseURL: process.env.API_CLOUD_URL,
  timeout: 10000,
  withCredentials: true,
});

var apiCloudInstanceNoErr = axios.create({
  baseURL: process.env.API_CLOUD_URL,
  timeout: 10000,
  withCredentials: true,
});


if (storejs.get(process.env.VUE_APP_APPKEY + "token")) {
  apiInstance.defaults.headers.common["Authorization"] =
    "Bearer " + storejs.get(process.env.VUE_APP_APPKEY + "token");
  apiCloudInstance.defaults.headers.common["Authorization"] =
    "Bearer " + storejs.get(process.env.VUE_APP_APPKEY + "token");
  apiCloudInstanceNoErr.defaults.headers.common["Authorization"] =
    "Bearer " + storejs.get(process.env.VUE_APP_APPKEY + "token");
}

export function cleanToken() {
  apiInstance.defaults.headers.common["Authorization"] = "";
  apiCloudInstance.defaults.headers.common["Authorization"] = "";
  apiCloudInstanceNoErr.defaults.headers.common["Authorization"] = "";
}

// 登录
export const loginS = (params) => {
  return apiCloudInstance.post(`api-study/v1/users/login`, params);
};

// JWT验证
export const authJWT = (params) => {
  return apiCloudInstance.post(`gw/v1/authorizations/jwt`, params);
};

export const getSimpleCaptcha = () => {
  return apiCloudInstance.get(`api-public/v1/captcha/simple`);
};

export const valilSimpleCaptcha = (params) => {
  return apiCloudInstance.get(`api-public/v1/captcha/simple/valil`, {
    params: params,
  });
};

// 发送手机验证码
export const sendSms = (params) => {
  return apiCloudInstance.get(`api-public/v1/sms`, { params: params });
};

// 验证手机验证码
export const validateMobileCode = (params) => {
  return apiCloudInstance.get(`api-public/v1/sms/code/valil`, {
    params: params,
  });
};

// 验证验证证件号唯一性
export const verificationStudent = (params) => {
  return apiInstance.get(`api/study/student/verificationStudent`, {
    params: params,
  });
};

// 验证手机号唯一性
export const vftelStudent = (params) => {
  return apiInstance.get(`api/study/student/vftelStudent`, { params: params });
};

// 验证用户名唯一性
export const checkUsername = (params) => {
  return apiInstance.get(`api/study/student/checkUsername`, { params: params });
};

// 学员注册
// export const studyRegister = params => {
//   return apiCloudInstance.post(`api-study/v1/users/register`, params);
// };

// 学员注册
export const studyRegister = (params) => {
  return apiCloudInstance.post(`openplatfrom-userserver/user/register`, params);
};
/**
 * @description: 学员微信登录后补充信息
 * @return {*}
 * @param params
 * @param token
 */
export const studyUpdateUserAllInfo = (params, token) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/updateUserAllInfo`,
    params
  );
};
/**
 * @description: 校验证件号是否正确 code2 证件重复
 * @return {*}
 * @param params
 */
export const studyValidSertId = (params) => {
  return apiCloudInstance.get(`openplatfrom-userserver/user/validSertId`, {
    params: params,
  });
};

// 验证用户登录名是否可以用
export const loginnameAvailable = (params) => {
  return apiCloudInstance.get(`api-study/v1/users/available/loginname`, {
    params: params,
  });
};
// 验证用户登录名证件号是否可用
export const nameSertIdAvailable = (params) => {
  return apiCloudInstance.get(`openplatfrom-userserver/user/available/value`, {
    params: params,
    hideMsg: true,
  });
};
/**
 * @description: 微信绑定账户
 */
export const wxBindByUserName = (params) => {
  return apiCloudInstance
    .post(`openplatfrom-userserver/wx/bindByUserName`, params)
    .then((res) => res.data);
};
// 验证用户证件号是否可用
export const sertIdAvailable = (params) => {
  return apiCloudInstance.get(`api-study/v1/users/available/sertId`, {
    params: params,
  });
};

export const teachManageLogin = (params) => {
  return apiInstance.post(`api/study/user/login`, params);
};

// 获得学员的字典信息
export const getUserDictByColumType = (params) => {
  return apiInstance.get(`api/study/student/getUserDictByColumType`, {
    params: params,
  });
};

// 获得省市县乡
export const getCustomAreaList = (params) => {
  return apiInstance.get(`api/study/public/getCustomAreaList`, {
    params: params,
  });
};

// 获得单位下的科室
export const getdepartmentByOrgId = (params) => {
  return apiInstance.get(`api/study/student/getdepartmentByOrgId`, {
    params: params,
  });
};

// 获得专业1
export const getSpecialty1Indexs = (params) => {
  return apiInstance.get(`api/study/student/getSpecialty1Indexs`, {
    params: params,
  });
};

// 获得专业2
export const getSpecialty2Indexs = (params) => {
  return apiInstance.get(`api/study/student/getSpecialty2Indexs`, {
    params: params,
  });
};

// 验证学员是否有学习前需要的考试
export const showExamVisible = (params) => {
  return apiInstance.get(`api/study/student/showExamVisible`, {
    params: params,
  });
};

// 轮播图列表
export const getRecommendList = (params) => {
  return apiCloudInstance.get(`api-cms/cms/carouselFigure/getRecommendList`, {
    params: params,
  });
};

// 资讯列表
// export const listNews = params => {
//   return apiInstance.get(`api/cms/news/list`, {params: params});
// };

export const getClientIp = () => {
  return apiCloudInstance.get(`api-public/v1/client/ip`);
};

export const getShopZhupei = (params) => {
  return apiCloudInstance.get(`api-mall/v1/goodsProduct/queryProductByIds`, {
    params: params,
  });
};

// 资讯列表
export const listNews = (params) => {
  return apiCloudInstance.get(`api-cms/v1/news`, { params: params });
};

// 获取订单信息
export const getBindTrainCourseGoods = (params) => {
  return apiCloudInstance.get(`api-public/v1/pay/getOrderList`, {
    params: params,
  });
};

// 获取培训班对应的商品列表
export const getLearningCard = (params) => {
  return apiCloudInstance.get(`api-public/v1/payGoods/getlearningCard`, {
    params: params,
    hideMsg: true,
  });
};

// 根据培训班编号查询商品
export const queryProductByTrainingCode = (params) => {
  return apiCloudInstance.get(
    `api-mall/v1/goodsProduct/queryProductByTrainingCode`,
    { params: params, hideMsg: true }
  );
};
// 根据培训班编号id培训班code
export const queryTrainingCode = (trainingId) => {
  return apiCloudInstance.get(`api-study/v1/trainings/${trainingId}`, {
    hideMsg: true,
  });
};

// 资讯详情
export const getNews = (params) => {
  return apiCloudInstance.get(`api-cms/cms/news/getNews`, { params: params });
};

// 精品课程
export const listPerfectCourse = (params) => {
  return apiInstance.get(`api/study/course/perfect/list`, { params: params });
};
// 通过id绑定培训班接口
export const postAddTrainingPersonnel = (params) => {
  return apiInstance.post(`api/study/participate/addTrainingPersonnel`, params);
};
// 通过id绑定培训班接口
export const addTrainingPersonnel = (userId, trainingId) => {
  return apiCloudInstance.get(
    `api-study/v1/trainings/addUser2Training?trainingId=${trainingId}&userId=${userId}`
  );
};
// 查询是否在这7个班中
export const getIsInTraining = (params) => {
  return apiInstance.get(`api/study/participate/isInTraining`, {
    params: params,
  });
};

// // 学员培训班列表
// export const listStudentTraining = params => {
//   return apiInstance.get(`api/study/student/listStudentTraining`, {params: params});
// };
// 学员培训班列表
export const listStudentTraining = (params) => {
  return apiInstance.get(`api/study/student/listStudentTrainingApp`, {
    params: params,
  });
};

// 学科分类
export const listDisciplineCategoryAndChild = () => {
  return apiInstance.get(`api/category/listDisciplineCategoryAndChild`);
};

// 项目和课程以及课程学习状态列表
export const listStudentProjCourseInfoAndStatus = (params) => {
  return apiInstance.get(
    `api/study/student/listStudentProjCourseInfoAndStatus`,
    { params: params }
  );
};

// 项目列表和学习状态列表
export const listStudentProjInfoAndStatus = (params) => {
  return apiInstance.get(`api/study/student/listStudentProjInfoAndStatus`, {
    params: params,
  });
};

// 继教我的项目列表
export const listStudentMyProjInfoAndStatus = (params) => {
  return apiInstance.get(`api/study/student/listStudentMyProjInfoAndStatus`, {
    params: params,
  });
};

// 课件列表
export const getCourseWareByCourse = (params) => {
  return apiInstance.get(`api/study/courseware/getCourseWareByCourse`, {
    params: params,
  });
};
// 获取视频进度
export const getVideoRecords = (params) => {
  return apiCloudInstanceNoErr.post(
    `api-video/v1/video/getVideoRecords`,
    params
  );
};
// 存储视频进度
export const saveVideoRecord = (params) => {
  return apiCloudInstanceNoErr.post(
    `api-video/v1/video/saveVideoRecord`,
    params
  );
};
/**
 * @description: 学习签到记录
 */
export const trainingSignIn = (params) => {
  return apiCloudInstanceNoErr.get(`/api-study/v1/trainings/signIn`, {
    params: params,
  });
};
// 设备检验接口(检测设备是否在线)
export const singleDeviceCheck = (params) => {
  // return apiCloudInstance.post(
  //   `/api-video/v1/video/singleDevice/check`,
  //   params
  // );
    return apiCloudInstance.get(
      `/api-video/v2/video/singleDevice/check`,
     {
       params: params
     }
    );

};

// 设备检验接口(切换设备)
export const singleDeviceSwitch = (params) => {
  // return apiCloudInstance.post(
  //   `/api-video/v1/video/singleDevice/switch`,
  //   params
  // );
    return apiCloudInstance.get(
      `/api-video/v2/video/singleDevice/switch`,
     {
       params: params
     }
    );
};

// 视频锁定
export const postVideoCheckOnlineStudy = (params) => {
  return apiCloudInstance.post(`api-study/v1/video/checkOnlineStudy`, params);
};

// 用户课程视频完成情况
export const getUserCoursePercent = (userId, params) => {
  return apiCloudInstance.get(
    `api-study/v1/users/` + userId + `/course/percent`,
    { params: params }
  );
};

// 用户提交课程评星
export const saveCourseRate = (params) => {
  return apiInstance.post(`api/study/courseware/rate/save`, params);
};

// 同步讲义状态
// export const syncHandoutStatus = (params) => {
//   return apiInstance.post(`api/study/course/syncHandoutStatus`, params);
// };
export const syncHandoutStatus = (params) => {
  // return apiInstance.post(`api/study/course/syncHandoutStatus/v2`, params);
   return apiCloudInstance.post(`/api-video/v2/video/syncHandoutStatus`, params, {
     hideMsg: true,
   });
};

// 同步课程状态
// export const syncCourseStatus = (params) => {
//   return apiInstance.post(`api/study/course/syncCourseStatus`, params);
// };
export const syncCourseStatus = (params) => {
  return apiInstance.post(`api/study/course/syncCourseStatus/v2`, params);
};

// 证书查询
export const getCertificate = (params) => {
  return apiInstance.get(`api/Certificate/getCertificate`, { params: params });
};
// 学分查询
export const queryCredit = (params) => {
  return apiCloudInstance.get(`api-study/v1/credit/creditStats`, {
    params: params,
  });
};

// 学员是否有思维训练
export const getUserThinking = (params) => {
  return apiInstance.get(`api/study/student/getUserThinking`, {
    params: params,
  });
};

// 绑定学习卡
export const bandLearningCard = (params) => {
  return apiInstance.post(`api/study/learningCard/bandLearningCard`, params);
};

// 我的培训
export const getMyTrainingList = (params) => {
  return apiInstance.get(`api/study/student/getMyTrainingList`, {
    params: params,
  });
};
// 我的培训v2
export const getMyTrainingListV2 = (params) => {
  return apiInstance.get(`api/study/student/getMyTrainingList/v2`, {
    params: params,
  });
};

// 根据培训班id获取培训班
export const getTrainingById = (params) => {
  return apiInstance.get(`api/study/training/getTrainingById`, {
    params: params,
  });
};

// 根据培训班id获取培训班
export const getTrainingInfoById = (params) => {
  return apiInstance.get(`api/study/training/getTrainingInfoById`, {
    params: params,
  });
};
// 获取课程进度v2
export const getUserCoursePercentv2 = (params) => {
  return apiCloudInstance.get(`/api-video/v2/video/getUserCoursePercent`, {
        params
      }
  );
};
// 上传课程进度v2
export const syncCourseStatusV2 = (params,uuid) => {
  const deviceinfo = Deviceinfo(uuid)
  ///api-video/v2/video/syncCourseStatus
  return apiCloudInstance.post(`/api-video/v2/video/syncCourseStatus`, params,  {
    headers: {
      "Content-Type": "application/json",
       "deviceinfo": deviceinfo
    },
     hideMsg: true,
  })
};

// 我的学分
export const getMyScoreList = (params) => {
  return apiInstance.get(`api/study/student/getMyScoreList`, {
    params: params,
  });
};
// 我的学分v2
export const getMyScoreListv2 = (params) => {
  return apiInstance.get(`api/study/student/getMyScoreList/v2`, {
    params: params,
  });
};

// 获取服务器当前时间
export const getServerNowTime = () => {
  return apiInstance.get(`api/study/student/getServerNowTime`);
};

// 我的学分(获取所有培训班的年份)
export const getMyScoreTrainingYear = (params) => {
  return apiInstance.get(`api/study/student/getMyScoreTrainingYear`, {
    params: params,
  });
};

// 我的学分 (根据年份获取对应的培训班)
export const getMyScoreTrainingName = (params) => {
  return apiInstance.get(`api/study/student/getMyScoreTrainingName`, {
    params: params,
  });
};

// 我的考试
export const getUserCenterExamLists = (params) => {
  return apiInstance.get(`api/study/student/usercenter/exam`, {
    params: params,
  });
};
// 我的考试v2
export const getUserCenterExamListsV2 = (params) => {
  return apiInstance.get(`api/study/student/usercenter/exam/v2`, {
    params: params,
  });
};

// 我的练习
export const getUserCenterPractiseLists = (params) => {
  return apiInstance.get(`api/study/student/usercenter/practise`, {
    params: params,
  });
};
// 我的练习V2
export const getUserCenterPractiseListsV2 = (params) => {
  return apiInstance.get(`api/study/student/usercenter/practise/v2`, {
    params: params,
  });
};

// 我的练习
export const validateUserCreditBindingTerm = (params) => {
  return apiInstance.get(
    `api/study/student/usercenter/validateUserCreditBindingTerm`,
    { params: params }
  );
};

// 绑卡记录
export const getMyCardList = (params) => {
  return apiInstance.get(`api/study/student/getMyCardList`, { params: params });
};

// 获取继教项目详情
export const getProjectDetail = (params) => {
  return apiInstance.get(`api/study/project/getProjectDetail`, {
    params: params,
  });
};

//获取学员的详细信息
export const getStudentDetail = (params) => {
  return apiInstance.get(`api/study/student/getStudentDetail`, {
    params: params,
  });
};

// 编辑学员的基本信息
export const updateStudent = (params) => {
  return apiInstance.post(`api/study/student/updateStudent`, params);
};

// 账号设置：修改手机号
export const updateMobile = (params) => {
  return apiInstance.post(`api/study/student/updateMobile`, params);
};

/**
 * @description: 修改密码
 */
export const userUpdatePassword = (params) => {
  return apiCloudInstance
    .post(`openplatfrom-userserver/user/updatePassword`, params)
    .then((res) => res.data);
};

// 绑定手机号
export const bindMobile = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/bindMobile`,
    params
  );
};
//修改绑定手机号
export const updatebindMobile = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/editMobile`,
    params
  );
};
/**
 * @description: 校验证件号是否是本人
 */
export const validSertIdIsOwn = (params) => {
  return apiCloudInstance.get(`openplatfrom-userserver/user/validSertIdIsOwn`, {
    params,
  });
};

// 账号设置：发送邮箱验证码
export const sendEmail = (params) => {
  return apiInstance.get(`api/public/email/sendEmail`, { params: params });
};

// 账号设置：验证邮箱验证码
export const validateEmailCode = (params) => {
  return apiInstance.get(`api/public/email/validateEmailCode`, {
    params: params,
  });
};

// 忘记密码
export const updatePwd = (params) => {
  return apiInstance.post(`api/study/student/updatePwd`, params);
};
//短信找回密码 新短信接口
export const updatePwdNew = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/editPasswordByMobile`,
    params
  );
};
//短信找回密码 校验手机号是否注册
export const isValidMoblile = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/validMobile`,
    params
  );
};
//证件号找回密码下一步
export const updatePwdValid = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/validUserInfo`,
    params
  );
};
//证件号找回密码确定
export const updatePwdSertId = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/editPasswordBySertId`,
    params
  );
};

//账号设置：修改密码（验证旧密码是否正确）
export const checkPwdRight = (params) => {
  return apiInstance.get(`api/study/student/checkPwdRight`, { params: params });
};

//账号设置：修改密码（验证旧密码是否正确）
export const updateEmail = (params) => {
  return apiInstance.get(`api/study/student/updateEmail`, { params: params });
};

//账号设置：修改密码（验证邮箱是否唯一）
export const vftelUserEmail = (params) => {
  return apiInstance.get(`api/study/student/vftelUserEmail`, {
    params: params,
  });
};

// 账号设置：修改密码
export const updatePassword = (params) => {
  return apiInstance.post(`api/study/student/updatePassword`, params);
};

// 我的考试列表 开始考试按钮的 验证
export const validateTrainingExam = (params) => {
  return apiInstance.get(`api/study/student/validateTrainingExam`, {
    params: params,
  });
};

// 获取继教项目的课程
export const getProjectCourse = (params) => {
  return apiInstance.get(`api/study/project/getProjectCourse`, {
    params: params,
  });
};

// 添加到我的项目
export const addMyProject = (params) => {
  return apiInstance.post(`api/study/project/usercenter/addMyProject`, params);
};

// 取消申请学分
export const calcelApplyCredit = (params) => {
  return apiInstance.post(`api/study/credit/calcelApplyCredit`, params);
};

// 申请学分
export const applyCredit = (params) => {
  return apiInstance.post(`api/study/credit/applyCredit`, params);
};

//查询培训班关联的考试要求设置
export const getUserTrainingExam = (params) => {
  return apiInstance.get(`/api/study/training/getUserTrainingExam`, {
    params: params,
  });
};

// 检测学员是否绑定了学习卡
export const haveBandedLearningCard = (params) => {
  return apiInstance.get(`api/study/learningCard/haveBandedLearningCard`, {
    params: params,
  });
};

// 根据单位名称模糊匹配获取单位信息，以及省市县乡
// export const listByCompName = params => {
//   return apiInstance.get(`api/study/comp/listByCompName`, {params: params});
// };

export const listCompany = (params) => {
  return apiCloudInstance
    .get(`api-study/v1/companys`, { params: params })
    .then((res) => res.data);
};

// 课后练习分数提交
export const commitCoursePracticeScore = (params) => {
  // return apiInstance.get(`api/WebApp/commitCoursePracticeScore`, {
  //   params: params,
  // });
    return apiCloudInstance.post(`/api-video/v2/video/commitPracticeScore`, params);
};

// 获取继教项目类别
export const getProjTypeList = (params) => {
  return apiInstance.get(`api/study/project/getProjDict`, { params: params });
};

// 获取继教学分类别
export const getCreTypeList = (params) => {
  return apiInstance.get(`api/study/project/getProjDict`, { params: params });
};

// 继教--添加到我的项目
export const addToMyProject = (params) => {
  return apiInstance.get(`api/study/project/addToMyProject`, {
    params: params,
  });
};

// 继教--从我的项目中移除
export const removeFromMyProject = (params) => {
  return apiInstance.get(`api/study/project/removeFromMyProject`, {
    params: params,
  });
};

//医搜索
export const MedicalSearch = (params) => {
  return apiInstance.post(`api/common/MedicalSearch`, params);
};

//判断学员是否是指定地区或医院
export const existAssignOrg = (params) => {
  return apiInstance.post(`api/study/student/existAssignOrg`, params);
};

// 获取考试的url
export const getBeginExamUrl = (params) => {
  return apiInstance.get(`api/study/public/getBeginExamUrl`, {
    params: params,
  });
};

// 获取练习的url
export const getBeginPracticeUrl = (params) => {
  return apiInstance.get(`api/study/public/getBeginPracticeUrl`, {
    params: params,
  });
};

// 获取查看考试的url
export const getViewExamAnswerUrl = (params) => {
  return apiInstance.get(`api/study/public/getViewExamAnswerUrl`, {
    params: params,
  });
};

// 获取二级登陆页配置信息
export const getSecondPageInfoById = (params) => {
  return apiInstance.get(`api/study/secondPage/getSecondPageInfoById`, {
    params: params,
  });
};

// 提交评论
export const saveComment = (params) => {
  return apiInstance.post(`api/comment/save`, params);
};

// 评论列表
export const listComment = (params) => {
  return apiCloudInstance.get(`api-cms/v1/comments/topic`, { params: params });
};

// 根据微信扫码第一步获取的code 获取access_token
export const getWXCallBack = (params) => {
  return apiCloudInstance.get(`api-weixin/v1/wx/callback`, { params: params });
};

// 根据微信扫码第一步获取的code 刷新access_token
// export const refreshAccessToken = params => {
//   return apiCloudInstance.get(`api-weixin/v1/wx/refreshAccessToken`, {params: params});
// };

// 微信openId绑定医博士账号
export const bandUser = (params) => {
  return apiCloudInstance.post(`api-study/v1/wxUser/bandUser`, params);
};

// 根据openId获取对应 医博士账户的 jwtToken
export const getJwtTokenByOpenId = (openIdWeb) => {
  return apiCloudInstance.get("api-study/v1/wxUser/" + openIdWeb + "/jwtToken");
};

// 支付统一下单
export const unifiedorder = (params) => {
  return apiCloudInstance.post(`api-public/v1/pay/unifiedorder`, params);
};

// 支付统一下单(新支付)
export const unifiedorderV2 = (params) => {
  return apiCloudInstance.post(`api-pay/v1/pay/unifiedorder/v2`, params);
};
//支付统一下单住培
export const unifiedorderzhupei = (params, Authorization) => {
  return apiCloudInstance.post(`api-pay/v1/pay/unifiedorder/v2`, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: Authorization,
    },
  });
};

// 笔记列表
export const listNotes = (userId, params) => {
  return apiCloudInstance.get(`api-study/v1/users/` + userId + `/notes`, {
    params: params,
  });
};
// 判断是否 是在学习之前 是否绑卡
export const bangDingCard = (trainingId, userId) => {
  return apiCloudInstance.get(
    `api-study/v1/trainings/incloudCard/${trainingId}/${userId}`
  );
};

// 增加笔记
export const saveNote = (userId, params) => {
  return apiCloudInstance.post(
    `api-study/v1/users/` + userId + `/notes`,
    params
  );
};

// 保存习题纠错
export const saveQuestionErrorCorrect = (params) => {
  return apiCloudInstance.post(`api-exam/questionErrorCorrect`, params);
};

// 绑定学习卡
export const validateBindCardBeforeExam = (params) => {
  return apiInstance.get(
    `api/study/student/usercenter/validateBindCardBeforeExam`,
    { params }
  );
};

//订单管理 订单列表
export const getOrderList = (params) => {
  return apiCloudInstance
    .get(`/api-public/v1/pay/getOrderList`, { params: params })
    .then((res) => res.data);
};
// 订单管理 订单列表new
export const getOrderListnew = (userid, params) => {
  return apiCloudInstance
    .get(`/api-pay/v1/pay/queryOrder/${userid}`, { params: params })
    .then((res) => res.data);
};

// 订单管理 订单列表newv2
export const getOrderListnewV2 = (params) => {
  return apiCloudInstance
    .get(`/api-pay/v1/pay/queryOrderv2`, { params: params })
    .then((res) => res.data);
};
// 查询订单是否支付成功
export const getPayQueryOrder = (params) => {
  return apiCloudInstance
    .get(`/api-pay/v1/pay/queryOrder`, { params: params })
    .then((res) => res.data);
};

//订单管理 发票申请
export const postApplyInvoice = (params) => {
  return apiCloudInstance.post(`/api-public/v1/invoice/applyInvoice`, params);
};

/**
 * @description: 是否可冲开发票
 */
export const validAgainApply = (params) => {
  return apiCloudInstance.get(`/api-public/v1/invoice/validAgainApply`, {
    params: params,
  });
};
/**
 * @description: 重新开票
 */
export const againApply = (params) => {
  return apiCloudInstance.post(`/api-pay/v2/order/againApply`, params);
};
//订单管理 发票申请 new
export const postApplyInvoiceNew = (params) => {
  return apiCloudInstance.post(`/api-pay/v2/order/apply`, params);
};
//订单管理 发票修改
export const postUpdateInvoice = (params) => {
  return apiCloudInstance.post(`/api-public/v1/invoice/updateInvoice`, params);
};

//订单管理 撤销申请发票
export const getCancelApplyInvoice = (id) => {
  return apiCloudInstance.get(`api-public/v1/invoice/cancelApplyInvoice/${id}`);
};

//订单管理 申请发票查询是否有以前记录, 反显以前填写信息
export const getUserInvoice = (userId, titleType) => {
  return apiCloudInstance.get(
    `api-public/v1/invoice/getUserInvoice/${userId}/${titleType}`
  );
};
//订单管理 查看申请发票信息
export const getInvoice = (id) => {
  return apiCloudInstance.get(`api-public/v1/invoice/getInvoice/${id} `);
};
//订单管理 查看申请发票信息
export const getInvoiceUrl = (id) => {
  return apiCloudInstance.get(`api-public/v1/invoice/getInvoiceUrl/${id} `);
};
//订单管理 查看发票信息
export const getInvoiceInfo = (params) => {
  return apiCloudInstance.get(`api-public/v1/invoice/queryInvoiceByOrderNo`, {
    params: params,
  });
};

//获取考试/练习题
export const queryCoursePractices = (params) => {
  return apiCloudInstance.get(`/api-study/v1/practice/queryCoursePractices`, {
    params: params,
  });
};
//获取考试/练习题new
export const queryCoursePracticesnew = (params) => {
  return apiCloudInstance.get(`/api-study/v4/practice/queryCoursePractices`, {
    params,
  });
};
//获取待评价项目列表
export const getEvaluateProjects = (params) => {
  return apiCloudInstance.get(`/api-study/v1/project/find/evaluate/projects`, {
    params: params,
  });
};
//学员提交评价接口
export const postEvaluateSubmit = (params) => {
  return apiCloudInstance.post(`/api-study/v1/project/evaluate/submit`, params);
};
//查询评价题
export const getProjectQueryEvaluate = (params) => {
  return apiCloudInstance.get(`/api-study/v1/project/queryEvaluate`, {
    params: params,
  });
};
//提交评价
export const postProjectSubmitEvaluate = (params) => {
  return apiCloudInstance.post(`/api-study/v1/project/submitEvaluate`, params);
};
/**
 * @description: 同意知情通知书
 * @return {*}
 * @param params
 */
export const trainingsAgreeInformedConsent = (params) => {
  return apiCloudInstance.get(`/api-study/v1/trainings/agreeInformedConsent`, {
    params,
  });
};

//获取加密人脸识别加密key
export const getFaceSecretKey = (params) => {
  return apiCloudInstance.get(
    `/api-study/v1/faceRecognition/getFaceSecretKey`,
    { params: params }
  );
};

//保存学习记录
export const saveWatchRecords = (params) => {
  return apiCloudInstance.post(
    `/api-study/v1/hunanStudy/saveWatchRecords`,
    params
  );
};

//校验是否人脸识别通过
export const getFaceResult = (params) => {
  return apiCloudInstance.get(`/api-study/v1/faceRecognition/getFaceResult`, {
    params: params,
  });
};

// ============================活动API=================================
//按地区查询当前是否有活动
export const getQueryActivity = (params) => {
  return apiCloudInstance
    .get(`/api-study/v1/activity/queryActivity`, { params: params })
    .then((res) => res.data);
};
//按地区查询当前是否有活动
export const getQueryDictByActivityId = (params) => {
  return apiCloudInstance
    .get(`/api-study/v1/activity/queryDictByActivityId`, { params: params })
    .then((res) => res.data);
};
//按地区查询当前是否有活动
export const getCountSizeForSanJi = (params) => {
  return apiCloudInstance
    .get(`/api-study/v1/trainings/countSizeForSanJi`, { params: params })
    .then((res) => res.data);
};
//根据培训班id查询是否允许更换类别
export const getIsReselectTraining = (params) => {
  return apiCloudInstance
    .get(`/api-study/v1/activity/isReselectTraining`, { params: params })
    .then((res) => res.data);
};

/*获取单位类别1*/
export const getCompType1 = (params) => {
  return apiInstance.get(`api/study/comp/getCompType1`, { params: params });
};
/*获取单位类别2*/
export const getCompType2 = (params) => {
  return apiInstance.get(`api/study/comp/getCompType2`, { params: params });
};

/**
 * @description: 学员报名信息
 */
export const registrationformGetRegistrationformForWeb = (params) => {
  return apiCloudInstance
    .get(`/api-public/registrationform/getRegistrationformForWeb`, {
      params: params,
    })
    .then((res) => res.data);
};
/**
 * @description: 删除报名学员(取消报名)
 */
export const registrationformRemoveUserContent = (params) => {
  return apiCloudInstance
    .post(`/api-public/registrationform/removeUserContent`, params)
    .then((res) => res.data);
};
/**
 * @description: 学员准考证列表
 */
export const examPermitList = (params) => {
  return apiCloudInstance
    .get(`/api-public/v1/exam/permit/myExamPermit/page`, { params })
    .then((res) => res.data);
};
/**
 * @description: 准考证预览
 */
export const examPermitPreview = (params) => {
  return apiCloudInstance
    .get(`/api-public/v1/exam/permit/preview`, { params })
    .then((res) => res.data);
};
/**
 * @description: 国家继教对接获取token
 */
export const getTokenByCMEToken = (token) => {
  return apiCloudInstance
    .get(
      `/openplatfrom-authserver/user/getTokenByCMEToken?token=${token}`
    )
    .then((res) => res.data);
};

/**
 * @description:  国家继教获取课程信息
 */
export const getTrain = (id,uuid) => {
  return apiCloudInstance
    .post(
      `/api-study/v1/cme/ncme/train?id=${id}&tainWay=1&uuid=${uuid}`
    )
    .then((res) => res.data);
};

/**
 * @description:  uuid获取token
 * 
 */
export const getTokenByUuid = (uuid) => {
  return apiCloudInstance.get(`/openplatfrom-authserver/oauth/getTokenByUuid?uuid=${uuid}`, {
  });
};

// 加载拦截
apiInstance.interceptors.request.use(
  function (config) {
    NProgress.start();
    //注意跟后台交互时array会被自动转换，
    if (config.method === "post") {
      config.data = qs.stringify(config.data);
    }

    //解决第一次登陆初始化实例没有token问题
    if (
      !apiInstance.defaults.headers.common["Authorization"] &&
      store.getters.token
    ) {
      config.headers.common["Authorization"] =
        "Bearer " + storejs.get(process.env.VUE_APP_APPKEY + "token");
    }
     config.headers.deviceinfo = Deviceinfo()
    return config;
  },
  function (error) {
    NProgress.done();
    return Promise.reject(error);
  }
);

apiInstance.interceptors.response.use(
  function (response) {
    NProgress.done();
    return response;
  },
  function (error) {
    if (!(error.config.url.indexOf("api/study/student/authJWT") != -1) ) {
      Message.error('网络异常！');
    }
    NProgress.done();
    return Promise.reject(error);
  }
);

// 不需要经过qs转换的api地址
const WhiteList = [
  "api-pay/v1/pay/unifiedorder/v2",
  "/api-study/v1/project/evaluate/submit",
  "/api-study/v1/hunanStudy/saveWatchRecords",
  "/api-video/v1/video/singleDevice/check",
  "/api-video/v1/video/singleDevice/switch",
  "/api-study/v1/project/submitEvaluate",
  "openplatfrom-userserver/user/updatePassword",
  '/api-study/v1/study/course/syncCourseStatus',
  '/api-video/v2/video/syncCourseStatus',
  '/api-video/v2/video/commitPracticeScore',
  '/api-video/v2/video/syncHandoutStatus',
];

apiCloudInstance.interceptors.request.use(
  function (config) {
    NProgress.start();
    if (
      config.method === "post" &&
      config.url.indexOf("api-exam") < 0 &&
      WhiteList.indexOf(config.url) === -1
    ) {
      config.data = qs.stringify(config.data);
    }

    //解决第一次登陆初始化实例没有token问题
    if (
      !apiCloudInstance.defaults.headers.common["Authorization"] &&
      store.getters.token
    ) {
      config.headers.common["Authorization"] =
        "Bearer " + storejs.get(process.env.VUE_APP_APPKEY + "token");
    }
    //上传记录接口需要browsertabid，其他默认空
    config.headers.deviceinfo = config.headers.deviceinfo||Deviceinfo()
    return config;
  },
  function (error) {
    NProgress.done();
    return Promise.reject(error);
  }
);

apiCloudInstance.interceptors.response.use(
  function (response) {
    NProgress.done();
    // !response.config.hideMsg  略过错误的msg提示
    if (response.data.code == 1 && !response.config.hideMsg) {
      Message.error(response.data.msg);
      return Promise.reject(response.data);
    }
    return response;
  },
  function (error) {
    if (!(error.config.url.indexOf("gw/v1/authorizations/jwt") != -1) && !(error.config.url.indexOf("/api-video/v2/video/sync") != -1)) {
      Message.error("网络异常！");
    }
 
    NProgress.done();
    return Promise.reject(error);
  }
);

apiCloudInstanceNoErr.interceptors.request.use(
  function (config) {
    NProgress.start();
    //注意跟后台交互时array会被自动转换，
    //https://www.npmjs.com/package/query-string
    if (config.method === "post" && config.url.indexOf("api-exam") < 0) {
      config.data = qs.stringify(config.data);
    }

    //解决第一次登陆初始化实例没有token问题
    if (
      !apiCloudInstanceNoErr.defaults.headers.common["Authorization"] &&
      store.getters.token
    ) {
      config.headers.common["Authorization"] =
        "Bearer " + storejs.get(process.env.VUE_APP_APPKEY + "token");
    }
   config.headers.deviceinfo = Deviceinfo()
    return config;
  },
  function (error) {
    NProgress.done();
    return Promise.reject(error);
  }
);

apiCloudInstanceNoErr.interceptors.response.use(
  function (response) {
    NProgress.done();
    // !response.config.hideMsg  略过错误的msg提示
    if (response.data.code == 1 && !response.config.hideMsg) {
      // Message.error(response.data.msg);
      return Promise.reject(response.data);
    }
    return response;
  },
  function (error) {
    if (!(error.config.url.indexOf("gw/v1/authorizations/jwt") != -1)) {
      // Message.error('网络异常！');
    }
    if (error.config.url.indexOf("api-video/v1/video/getVideoRecords") != -1 && error.response && error.response.status === 401) {
      Message({
        message: '登录信息失效, 请重新登录',
        type: 'error',
        duration: 3000
      })
   }
    NProgress.done();
    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./src/api/api_new.js